module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/9DPGqd/tc-custom/9780547892528.jpg?1718106104635",
      "alt": "This image is the cover for the book If The Creek Don't Rise"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("If The Creek Don't Rise\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("When Rita Williams was four, her mother died in a Denver boarding house. This death delivered Rita into the care of her aunt Daisy, the last surviving African American widow of a Union soldier and a maverick who had spirited her sharecropping family out of the lynching South and reinvented them as ranch hands and hunting guides out West. But one by one they slipped away, to death or to an easier existence elsewhere, leaving Rita as Daisy's last hope to right the racial wrongs of the past and to make good on a lifetime of thwarted ambition. If the Creek Don't Rise tells how Rita found her way out from under this crippling legacy and, instead of becoming \"a perfect credit to her race,\" discovered how to become herself. "), _c('br'), _c('br'), _vm._v("Set amid the harsh splendor of the Colorado Rockies, this is a gorgeous, ruthless, and unique account of the lies families live-and the moments of truth and beauty that save us. "), _c('br'), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rita Williams\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Houghton Mifflin Harcourt (www.hmhco.com)\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0